(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mileage-tabs"] && !Shopify.designMode) return;
  try {
    
  function initMileageSection(section) {
    var tabs = Array.prototype.slice.call(section.querySelectorAll('[data-mileage-tab]'));
    var slides = Array.prototype.slice.call(section.querySelectorAll('[data-mileage-slide]'));
    var texts = Array.prototype.slice.call(section.querySelectorAll('[data-mileage-text]'));
    var bars = tabs.map(function (btn) {
      return btn.querySelector('[data-mileage-progress]');
    });
    if (tabs.length < 2) return;

    var duration = parseInt(section.getAttribute('data-interval') || '6000', 10);
    if (!duration || duration < 1500) duration = 6000;
    var autoRotate = section.getAttribute('data-auto-rotate') !== 'false';

    var activeIndex = 0;
    var startTs = 0;
    var rafId = 0;
    var running = false;
    var observer = null;

    function setActive(i) {
      activeIndex = i;
      renderProgress(0);

      tabs.forEach(function (btn, idx) {
        var on = idx === i;
        btn.classList.toggle('is-active', on);
        btn.setAttribute('aria-selected', on ? 'true' : 'false');
      });

      slides.forEach(function (slide, idx) {
        slide.classList.toggle('is-active', idx === i);
      });

      texts.forEach(function (p, idx) {
        var on = idx === i;
        p.classList.toggle('is-active', on);
        if (on) {
          p.removeAttribute('hidden');
        } else {
          p.setAttribute('hidden', '');
        }
      });
    }

    function clearAllProgress() {
      bars.forEach(function (bar) {
        if (bar) bar.style.width = '0%';
      });
    }

    function renderProgress(p) {
      var v = Math.max(0, Math.min(1, p));
      bars.forEach(function (bar, idx) {
        if (!bar) return;
        bar.style.width = idx === activeIndex ? String(v * 100) + '%' : '0%';
      });
    }

    function step(ts) {
      if (!running) return;
      if (!startTs) startTs = ts;
      var elapsed = ts - startTs;
      var p = elapsed / duration;
      renderProgress(p);
      if (p >= 1) {
        startTs = ts;
        setActive((activeIndex + 1) % tabs.length);
      }
      rafId = window.requestAnimationFrame(step);
    }

    function start() {
      if (running || !autoRotate) return;
      running = true;
      startTs = 0;
      renderProgress(0);
      rafId = window.requestAnimationFrame(step);
    }

    function stop() {
      running = false;
      startTs = 0;
      if (rafId) window.cancelAnimationFrame(rafId);
      rafId = 0;
      clearAllProgress();
    }

    tabs.forEach(function (btn, idx) {
      btn.addEventListener('click', function () {
        setActive(idx);
        if (running) startTs = 0;
      });
    });

    // Preload all slide images so the crossfade doesn't stall
    slides.forEach(function (slide) {
      var imgs = slide.querySelectorAll('img');
      imgs.forEach(function (img) {
        var src = img.currentSrc || img.src;
        if (src) {
          var p = new Image();
          p.decoding = 'async';
          p.src = src;
        }
      });
    });

    setActive(0);

    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(
        function (entries) {
          var entry = entries && entries[0];
          if (!entry) return;
          if (entry.isIntersecting) start();
          else stop();
        },
        { threshold: 0.35 }
      );
      observer.observe(section);
    } else if (autoRotate) {
      start();
    }

    // Theme editor: don't auto-rotate so blocks stay editable
    if (window.Shopify && Shopify.designMode) {
      stop();
    }
  }

  function bootMileageTabs() {
    document.querySelectorAll('[data-mileage-section]').forEach(initMileageSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootMileageTabs);
  } else {
    bootMileageTabs();
  }

  // Shopify theme editor re-renders sections on edit — re-init when needed
  document.addEventListener('shopify:section:load', function (e) {
    var target = e.target && e.target.querySelector('[data-mileage-section]');
    if (target) initMileageSection(target);
  });

  } catch(e) { console.error(e); }
})();
})();
